import React from 'react';

const TermsOfService = () => (
    <div className="p-6 bg-secondary">
        <div className="container mx-auto max-w-4xl space-y-6">
            
            <h1 className="text-3xl font-bold text-center text-primary">Terms and Services Disclaimer</h1>
            
            <p className="text-sm italic">As of November 2024</p>
            
            <p>Welcome to Elevate LLC’s website, located at www.elevate.com. By accessing or using our website, you agree to the 
                following terms and conditions. If you do not agree to these terms, please refrain from using our website.</p>
            
            <p className="italic text-sm">
                Disclaimer: This Terms and Services template is intended as a general guide. Consulting a legal professional 
                to tailor these terms specifically to your business is advisable.
            </p>

            <h2 className="text-2xl font-semibold text-primary">1. Use of Website</h2>
            <p>This website and its contents are intended solely for informational purposes. The information provided does not 
                constitute professional advice or services and should not be relied upon as such.</p>
            <p>Users agree to use this website only for lawful purposes and not engage in any prohibited activities.</p>

            <h2 className="text-2xl font-semibold text-primary">2. Intellectual Property</h2>
            <p>
                All content, design elements, logos, images, and other materials on this website are owned by Elevate LLC or 
                licensed to us. Unauthorized reproduction, modification, or distribution of any content is prohibited without 
                prior written permission from Elevate LLC.
            </p>
            <p>Content may be downloaded or printed for personal, non-commercial use only, provided all copyright and proprietary 
                notices are maintained.</p>

            <h2 className="text-2xl font-semibold text-primary">3. Limitation of Liability</h2>
            <p>
                Elevate LLC is not liable for any damages resulting from the use or inability to use the website or its contents, 
                including but not limited to errors, omissions, interruptions, or inaccuracies.
            </p>
            <p>
                We are not responsible for any direct, indirect, incidental, special, or consequential damages arising from your use 
                of this website, even if advised of the possibility of such damages.
            </p>

            <h2 className="text-2xl font-semibold text-primary">4. External Links</h2>
            <p>
                This website may contain links to third-party websites. These links are provided solely for convenience and do not 
                imply endorsement or control over their content by Elevate LLC.
            </p>
            <p>
                Elevate LLC is not responsible for the accuracy, completeness, legality, or availability of any information on 
                third-party sites.
            </p>

            <h2 className="text-2xl font-semibold text-primary">5. Privacy and Data Collection</h2>
            <p>
                We respect your privacy and handle your personal information in accordance with our Privacy Policy. By using our website, 
                you consent to the collection and use of information as outlined in the Privacy Policy.
            </p>

            <h2 className="text-2xl font-semibold text-primary">6. Indemnification</h2>
            <p>
                You agree to indemnify, defend, and hold harmless Elevate LLC, its employees, directors, agents, and affiliates from 
                and against any claims, liabilities, damages, losses, or expenses, including reasonable attorneys&apos; fees, arising out 
                of or related to your use of the website or violation of these Terms and Services.
            </p>

            <h2 className="text-2xl font-semibold text-primary">7. Changes to Terms</h2>
            <p>
                Elevate LLC reserves the right to update or modify these Terms and Services at any time without prior notice. 
                Your continued use of the website after changes are posted constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-2xl font-semibold text-primary">8. Governing Law</h2>
            <p>
                These terms shall be governed by and interpreted in accordance with the laws of the State of Delaware. 
                Any disputes arising from these terms or your use of the website will be subject to the exclusive jurisdiction 
                of the courts of Delaware.
            </p>

            <h2 className="text-2xl font-semibold text-primary">9. Contact Us</h2>
            <p>
                If you have questions or need further assistance, please contact us 
                at <a href="mailto:contact@elevate.com" className="text-blue-600 hover:underline">contact@elevate.com</a>.
            </p>

            <h2 className="text-2xl font-semibold text-primary">Copyright Disclaimer</h2>
            <p>
                © 2024 Elevate LLC. All rights reserved. The content of this website, including but not limited to text, 
                graphics, images, logos, and other material, is protected by copyright law and is the exclusive property 
                of Elevate LLC or used under license. Unauthorized use, reproduction, or distribution of any content is 
                strictly prohibited without prior written consent. Violators will be subject to applicable civil and criminal penalties.
            </p>
        </div>
    </div>
);

export default TermsOfService;
